const persistenceStateKeys = {
  step: 'etba/buy_campaign/step',
  selectedRecipientId: 'etba/buy_campaign/selectedRecipientId',
  selectedShippingMethodId: 'etba/buy_campaign/selectedShippingMethodId',
  isCreatingNewRecipient: 'etba/buy_campaign/isCreatingNewRecipient',
  recipientFormMode: 'etba/buy_campaign/recipientFormMode',
}

export default persistenceStateKeys
